<template>
  <div
    :class="classes"
    :style="styles"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'c-row',
  props: {
    verticalAlign: {
      type: String,
      default: 'center'
    },
    horizontalAlign: {
      type: String,
      default: 'center'
    },
    noGutters: {
      type: Boolean,
      default: false
    },
    flexDirectionClasses: {
      type: String,
      default: '',
      required: false
    },
    experience: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: false,
    },
    borderColor: {
      type: String,
      default: '#074E8E',
    },
    borderWidth: {
      type: String,
      default: '1px'
    },
    borderRadius: {
      type: String,
      default: '5px'
    },
    gapMobile: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
    gapTablet: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
    gapDesktop: {
      type: String,
      default: '',
      validator: (value) => ['', 'small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    classes() {
      return [
        'row',
        `row--v-${this.verticalAlign}`,
        `row--h-${this.horizontalAlign}`,
        `${this.flexDirectionClasses}`,
        this.gapMobile ? `c-gap-mobile-${this.gapMobile}` : '',
        this.gapTablet ? `c-gap-tablet-${this.gapTablet}` : '',
        this.gapDesktop ? `c-gap-desktop-${this.gapDesktop}` : '',
        { 'no-gutters': this.noGutters },
        { 'row--experience': this.experience },
        { 'row--b-has-border': this.hasBorder }
      ]
    },
    styles() {
      return {
        'border-color': this.hasBorder ? this.borderColor : '',
        'border-width': this.hasBorder ? this.borderWidth : '',
        'border-radius': this.hasBorder ? this.borderRadius : ''
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .row {
    z-index: 1;
    position: relative;
    width: 100%;
    margin-left: 0;
    margin-right: 0;

    &--v-top {
      align-items: flex-start;
    }

    &--v-center {
      align-items: center;
    }

    &--v-bottom {
      align-items: flex-end;
    }

    &--v-fill {
      align-items: stretch;
    }

    &--h-left {
      justify-content: flex-start;
    }

    &--h-center {
      justify-content: center;
    }

    &--h-right {
      justify-content: flex-end;
    }

    &--h-fill {
      justify-content: stretch;
      & > * {
        flex-grow: 1;
      }
    }

    &--experience {
      padding-top: 30px;
      border: 1px solid blue;

      &::before {
        content: '[ - row - ]';
        position: absolute;
        top: 0;
        font-size: 12px;
      }
    }

    &--b-has-border {
      border: solid 1px #074E8E;
    }
  }
</style>
